module.exports = __webpack_public_path__ + "static/Antonin_Leuret-a9d1bd084eeb798fc88419f87d814215.png";